export default "{{data}}"